import { createContext, useState, useContext, useEffect } from 'react'
import { useTheme } from 'styled-components'
import { global } from '@navinc/utils'
import { request } from '../utils/request'

const isGQLOk = ({ data }) => (data.errors ? Promise.reject(data.errors) : data)
const PartnerConfigContext = createContext({
  isLoading: false,
  errors: null,
  partnerConfig: {},
  getIsPartnerClover: () => {},
  getIsPartnerSeek: () => {},
  getIsPartnerCreditSuite: () => {},
  getIsPartnerCreditSafe: () => {},
})
const fetchPartnerConfig = () => request({ url: `${global.location.origin}/partner/config` }).then(isGQLOk)

const addDefaults = ({ partner: { ...partnerConfig }, ...rest }, theme) => {
  const navLogoURL = 'https://design-assets.nav.com/logos/nav-logo-purple.svg'
  return {
    partner: {
      logoURL: navLogoURL,
      ...partnerConfig,
    },
    ...rest,
  }
}

export const PartnerConfigProvider = (props) => {
  const theme = useTheme()
  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState(null)
  const [partnerConfig, setPartnerConfig] = useState({})
  const [configurations, setConfigurations] = useState({})
  const { name: partnerName = '' } = partnerConfig

  const isPartnerByName = (nameToVerify) => partnerName.toLowerCase().includes(nameToVerify)
  const isPartnerClover = isPartnerByName('clover')
  const isPartnerSeek = isPartnerByName('seek')
  const isPartnerCreditSuite = isPartnerByName('credit suite')
  const isPartnerCreditSafe = isPartnerByName('creditsafe')

  useEffect(() => {
    let isCancelled

    setIsLoading(true)
    fetchPartnerConfig()
      .then((data) => addDefaults(data, theme))
      .then(({ partner, configurations }) => {
        if (!isCancelled) {
          setPartnerConfig(partner)
          setConfigurations(configurations)
          setIsLoading(false)
        }
      })

      .catch((error) => {
        if (!isCancelled) {
          setErrors(error)
          setIsLoading(false)
        }
      })

    return () => {
      isCancelled = true
    }
  }, [theme])

  return (
    <PartnerConfigContext.Provider
      value={{
        isLoading,
        errors,
        partnerConfig,
        configurations,
        getIsPartnerClover: () => isPartnerClover,
        getIsPartnerSeek: () => isPartnerSeek,
        getIsPartnerCreditSuite: () => isPartnerCreditSuite,
        getIsPartnerCreditSafe: () => isPartnerCreditSafe,
      }}
      {...props}
    />
  )
}

export const usePartnerConfig = () => useContext(PartnerConfigContext)
